module.exports = __webpack_public_path__ + "img/tab-white.6e43d5be.svg";